export enum ListadoAsignaciones {
  Pendientes,
  Manual,
  Asignados
}